module.exports = __webpack_public_path__ + "img/usdt_head.e17624cb.png";